var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.autopilotprojects)?_c('div',{staticClass:"project-autopilots-details"},[_c('div',{staticClass:"project-autopilots-details-head"},[_c('TText',{attrs:{"text":_vm.autopilot.function,"font_weight":"500","size":"24"}}),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.updateUObject({
            url: [
              { projects: _vm.project_id },
              { autopilotprojects: _vm.autopilotprojects.id }
            ],
            update: {
              active: !_vm.autopilotprojects.active
            }
          })}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" "+_vm._s(_vm.autopilotprojects.active ? 'mdi-play' : 'mdi-pause')+" ")])],1)]}}],null,false,3772885549)},[_c('span',[_vm._v(" "+_vm._s(_vm.autopilotprojects.active ? 'currently active' : 'currently paused')+" ")])])],1),_c('div',{staticStyle:{"display":"flex","grid-gap":"8px","align-items":"center"}},_vm._l((_vm.getUObjectsFiltered({type: 'autopilots', filter: {function: _vm.autopilot.function}})),function(level){return _c('v-btn',{key:`aplevel${level.id}`,staticClass:"ml-1",attrs:{"small":"","color":_vm.autopilot.id === level.id?'green':''},on:{"click":function($event){_vm.autopilot.id !== level.id?
        _vm.updateUObject({
          url: [
          {projects: _vm.project_id},
          {autopilotprojects: _vm.autopilotprojects.id}
          ],
          update: {
            'add#autopilots': [level.id]
          }
        }).then(() => {
          _vm.updateUObject({
            url: [
            {projects: _vm.project_id},
            {autopilotprojects: _vm.autopilotprojects.id}
            ],
            update: {
              'remove#autopilots': [_vm.autopilotprojects.autopilots[0]]
            }
          })
          })
        :
        ''}}},[_vm._v(" "+_vm._s(level.level)+" ")])}),1),_c('TText',{attrs:{"text":_vm.autopilot.description,"font_weight":"400"}}),_c('ButtonOutlined',{attrs:{"text":"Remove","icon":"bin","color":"red","width":"128","height":"36"},on:{"buttonClicked":function($event){_vm.deleteUObject({
      url: [
        { projects: _vm.project_id },
        { autopilotprojects: _vm.autopilotprojects.id },
      ]
      }).then(() => {
        _vm.$router.push({name: 'ProjectAutoPilots'})
      })}}}),_c('TText',{attrs:{"text":'WORK.package mappers',"font_weight":"500","size":"24"}}),_c('TFlex',{attrs:{"wrap":"wrap"}},[_vm._l((_vm.getUObjects({ type: 'twpmappers', ids: _vm.getUObject({type:'autopilotprojects', id: _vm.$route.params.autopilot_id}).twpmappers})),function(twpmapper){return _c('TWPMapper',{key:`twpmappers${twpmapper.id}`,staticClass:"ma-2",attrs:{"twpmapper":twpmapper},on:{"changeMapper":function($event){return _vm.updateUObject({
          url: [
            {projects: _vm.$route.params.project_id},
            {autopilotprojects: _vm.$route.params.autopilot_id},
            {twpmappers: twpmapper.id}
          ],
          update: $event
        })},"deleteMapper":function($event){return _vm.deleteUObject({
          url: [
            {projects: _vm.$route.params.project_id},
            {autopilotprojects: _vm.$route.params.autopilot_id},
            {twpmappers: twpmapper.id}
          ]
        })}}})}),_c('TWPMapper',{staticClass:"ma-2",on:{"changeMapper":function($event){return _vm.createUObject({
        url: [
          {projects: _vm.$route.params.project_id},
          {autopilotprojects: _vm.$route.params.autopilot_id},
          {twpmappers: ''},
          {showWithEntitiesNormalized: ''},
        ],
        u_object: $event
      })}}})],2),_c('TText',{attrs:{"text":'Issues',"font_weight":"500","size":"24"}}),_c('TFlex',{attrs:{"wrap":"wrap"}},_vm._l((_vm.autopilotissues_filtered),function(issue){return _c('v-card',{key:`issue${issue.id}`,staticClass:"ma-2",style:(`color: ${issue.parent.textcolor}`),attrs:{"color":issue.parent.color,"max-width":"344"}},[(issue.parent_type === 'twork_package')?_c('div',[_c('WorkPackageHead',{attrs:{"head":{
          token: issue.parent.token,
          name: issue.parent.name,
          icon: issue.parent.icon,
          area: issue.parent.taktarea_name,
          status_done_count: _vm.$store.state.Ultra.status_array.findIndex(status => status.name === issue.parent.status),
          status_is_stop: issue.parent.stop_status,
        },"foreground_color":_vm.getColor(issue.parent.textcolor),"readonly":true}}),_c('v-card-subtitle',[_vm._v("ISSUE.status: "),_c('b',[_vm._v(_vm._s(issue.status))])]),_c('v-card-text',[_vm._v(" "+_vm._s(issue.logentries[0].value)+" ")]),_c('v-card-actions',[_c('v-btn',{on:{"click":function($event){return _vm.updateUObject({
            url: [
              { projects: _vm.project_id },
              { autopilotissues: issue.id },
            ],
            update: { status: issue.status === 'resolved' ? 'open' : 'resolved' }
            })}}},[_vm._v(" "+_vm._s(issue.status === 'resolved' ? 'reopen' : 'resolve')+" ")]),_c('v-btn',{on:{"click":function($event){return _vm.routeToParent(issue)}}},[_vm._v("go to work package")])],1)],1):_vm._e()])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }